import type { FC } from "react";

import { useConfig } from "@jti/app-context/useConfig";
import { ArrowForwardIcon } from "@jti/brand-icons/arrow-forward";
import { useTranslations } from "@jti/ui";

import styles from "./OrderSummaryRedirectToOrder.module.scss";

export type OrderSummaryRedirectToOrderProps = {
  isFreeTrial: boolean;
  orderId?: string;
};

export const OrderSummaryRedirectToOrder: FC<OrderSummaryRedirectToOrderProps> = ({ orderId, isFreeTrial }) => {
  const { __ } = useTranslations();
  const { PROFILE_PAGE_URL } = useConfig();

  if (!orderId) {
    return null;
  }
  const linkHref = `${PROFILE_PAGE_URL}#/${isFreeTrial ? "trial" : "orders"}/${orderId}`;

  return (
    <div className={styles.orderSummaryRedirectToOrder}>
      <span className={styles.text}>{__("cart.order.summary.summaryLink", [orderId])}</span>
      <a className={styles.link} href={linkHref} aria-label={__("cart.order.summary.summaryLink", [orderId])}>
        <ArrowForwardIcon className={styles.icon} width="32px" height="22px" />
      </a>
    </div>
  );
};
